import { useCallback, useRef } from 'react';

export const useTrottle = () => {
  const trottleRef = useRef<NodeJS.Timeout>(null);

  const trottle = useCallback(
    (callback: () => void, timeout: number) => {
      if (trottleRef.current) {
        trottleRef.current = null;
        clearTimeout(trottleRef.current);
      }
      trottleRef.current = setTimeout(() => {
        callback();
        clearTimeout(trottleRef?.current);
      }, timeout);
    },
    [trottleRef]
  );

  return trottle;
};
